import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { NormalizeDecimalSeparatorDirective } from '../../../directives/normalize-decimal-separator.directive';
import { NumericCellEditorBaseComponent } from '../numeric-cell-editor-base/numeric-cell-editor-base.component';

/**
 * InLine Numeric Input Custom Editor
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-numeric-cell-editor-inline',
    templateUrl: './numeric-cell-editor-inline.component.html',
    styleUrls: ['./numeric-cell-editor-inline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslateModule,
        FocusSelectOnDirective,
        NormalizeDecimalSeparatorDirective,
    ],
})
export class NumericCellEditorInlineComponent extends NumericCellEditorBaseComponent {}
